import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Switch } from '@factorialco/f0-react/dist/experimental'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'
import app from 'modules/core/store/models/app'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { useCreateTrainingClassMembership } from 'modules/trainings/hooks/TrainingClassMemberships/useCreateTrainingClassMembership'

export const AddParticipantsToClassModal = ({ employeeIds }: { employeeIds: number[] }) => {
  const { navigation } = useNavigation()
  const { id, classId } = useParams()
  const navigate = useNavigate()
  const { company } = useCurrentSession()
  const { createTrainingClassMemberships } = useCreateTrainingClassMembership()

  const [selectedEmployees, setSelectedEmployees] = useState<EmployeesEmployeeSelectorInput>({
    type: 'manual',
    ids: [],
  })
  const [showTerminatedEmployees, setShowTerminatedEmployees] = useLocalStorage<boolean>(
    'trainings-participants-showTerminatedEmployees',
    true
  )

  const onSubmit = async () => {
    const result = await createTrainingClassMemberships({
      trainingClassIds: [Number(classId)],
      selection: selectedEmployees,
      companyId: company.id,
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'trainings.trainings_revamp.classes_sidepanel.participants.datatable.error'
        ),
      })
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(
          'trainings.trainings_revamp.classes_sidepanel.participants.datatable.success_add'
        ),
      })
    }
    navigate(
      navigation.trainings.list.details_revamp.view.trainingClasses.detail.participants.fullPath({
        id: Number(id),
        classId: Number(classId),
      })
    )
  }

  return (
    <Modal
      title={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.add_participants_modal.title'
      )}
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.add_participants_modal.description'
      )}
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.trainingClasses.detail.participants.fullPath(
            { id: Number(id), classId: Number(classId) }
          )
        )
      }
      footer={
        <Box gap="s8" flexDirection="row">
          <Button onClick={onSubmit} type="negative">
            {i18n.t('trainings.trainings_revamp.classes_sidepanel.participants.datatable.select')}
          </Button>
        </Box>
      }
    >
      <Box gap="s16">
        <EmployeeSelectorV2
          onChange={setSelectedEmployees}
          filters={['jobRole', 'team', 'workplace', 'legalEntity']}
          forcedFilters={{
            includeInactive: showTerminatedEmployees ?? true,
            excludeIds: employeeIds,
          }}
          multiple
        />
        <Switch
          title={i18n.t(
            'trainings.trainings_revamp.training_detail.employees_table.add_participants_modal.showTerminated'
          )}
          checked={showTerminatedEmployees ?? true}
          onCheckedChange={(checked: boolean) => setShowTerminatedEmployees(checked)}
        />
      </Box>
    </Modal>
  )
}
